import { AlertCircle } from "lucide-react";
import { PROPAGATION_OVERALL_STATUS, PropagationOverallStatus } from "@/utils/campaign-types";

interface PropagationHeaderData {
  total_stores: number;
  success_count: number;
  failed_count: number;
  pending_count: number;
  overall_status: PropagationOverallStatus;
}

interface PropagationKpiCardsProps {
  header: PropagationHeaderData;
}

interface KpiCardProps {
  label: string;
  value: number | string;
  sublabel?: string;
  valueClassName?: string;
}

function KpiCard({ label, value, sublabel, valueClassName }: KpiCardProps) {
  return (
    <div className="rounded-lg border bg-card p-4">
      <div className="text-sm font-medium text-muted-foreground">{label}</div>
      <div className={`text-2xl font-bold ${valueClassName || ""}`}>{value}</div>
      {sublabel && <div className="text-xs text-muted-foreground">{sublabel}</div>}
    </div>
  );
}

export function PropagationKpiCards({ header }: PropagationKpiCardsProps) {
  const successPercentage = Math.round((header.success_count / header.total_stores) * 100);
  const failedPercentage = header.total_stores > 0
    ? Math.round((header.failed_count / header.total_stores) * 100)
    : 0;
  const pendingPercentage = header.total_stores > 0
    ? Math.round((header.pending_count / header.total_stores) * 100)
    : 0;

  return (
    <div className="grid gap-4 md:grid-cols-5">
      <KpiCard label="Total de Lojas" value={header.total_stores} />

      <KpiCard
        label="Sucesso"
        value={header.success_count}
        sublabel={`${successPercentage}%`}
        valueClassName="text-green-500"
      />

      <KpiCard
        label="Falha"
        value={header.failed_count}
        sublabel={`${failedPercentage}%`}
        valueClassName="text-red-500"
      />

      <KpiCard
        label="Pendente"
        value={header.pending_count}
        sublabel={`${pendingPercentage}%`}
        valueClassName="text-yellow-500"
      />

      <div className="rounded-lg border bg-card p-4">
        <div className="text-sm font-medium text-muted-foreground">Status Geral</div>
        <div className="mt-2 flex items-center gap-2">
          {header.overall_status === PROPAGATION_OVERALL_STATUS.SUCCESS ? (
            <span className="inline-flex items-center gap-1 text-sm font-medium text-green-500">
              ✓ Concluído
            </span>
          ) : header.overall_status === PROPAGATION_OVERALL_STATUS.FAILED ? (
            <span className="inline-flex items-center gap-1 text-sm font-medium text-red-500">
              <AlertCircle className="h-4 w-4" />
              Falhou
            </span>
          ) : header.overall_status === PROPAGATION_OVERALL_STATUS.PARTIAL_FAILURE ? (
            <span className="inline-flex items-center gap-1 text-sm font-medium text-orange-500">
              <AlertCircle className="h-4 w-4" />
              Parcial
            </span>
          ) : (
            <span className="inline-flex items-center gap-1 text-sm font-medium text-blue-500">
              ⟳ Em Progresso
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
